import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ResumeReading from './ResumeReading';
import HomeBgm from './HomeBgm';
import './FloatingTools.css';

export default function FloatingTools() {
  const { pathname, key } = useLocation();
  const [expanded, setExpanded] = useState(false);
  const isReading = /^\/bible(?:\/|$)/.test(pathname);
  const showBgm = pathname === '/' || isReading;
  useEffect(() => { setExpanded(false); }, [key]);
  return (
    <div className={`floating-tools${isReading ? ' floating-tools--reading' : ''}${expanded ? ' floating-tools--expanded' : ''}`}>
      <ResumeReading />
      {showBgm && <>
        <div id="floating-bgm-panel" className="floating-tools__bgm"><HomeBgm /></div>
        {isReading && <button
          type="button"
          className="floating-tools__toggle"
          aria-label={expanded ? 'BGM操作パネルを閉じる' : 'BGM操作パネルを開く'}
          aria-expanded={expanded}
          aria-controls="floating-bgm-panel"
          onClick={() => setExpanded((value) => !value)}
        >{expanded ? '閉じる ×' : '♪ BGM'}</button>}
      </>}
    </div>
  );
}
